/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FirstPaymentCohortRow interface.
 */
export function instanceOfFirstPaymentCohortRow(value) {
    if (!('byTier' in value) || value['byTier'] === undefined)
        return false;
    if (!('cohortMonth' in value) || value['cohortMonth'] === undefined)
        return false;
    if (!('newPayers' in value) || value['newPayers'] === undefined)
        return false;
    return true;
}
export function FirstPaymentCohortRowFromJSON(json) {
    return FirstPaymentCohortRowFromJSONTyped(json, false);
}
export function FirstPaymentCohortRowFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'byTier': json['byTier'],
        'cohortMonth': json['cohortMonth'],
        'newPayers': json['newPayers'],
    };
}
export function FirstPaymentCohortRowToJSON(json) {
    return FirstPaymentCohortRowToJSONTyped(json, false);
}
export function FirstPaymentCohortRowToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'byTier': value['byTier'],
        'cohortMonth': value['cohortMonth'],
        'newPayers': value['newPayers'],
    };
}
